import {DatePicker, DateTimePicker, faIR, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFnsJalali} from "@mui/x-date-pickers/AdapterDateFnsJalali";

const persianLocale = {
    ...faIR.components.MuiLocalizationProvider.defaultProps.localeText,
    okButtonLabel: 'تایید',
    // Field section placeholders
    fieldYearPlaceholder: () => 'سال',
    fieldMonthPlaceholder: (params) => (params.contentType === 'letter' ? 'ماه' : 'ماه'),
    fieldDayPlaceholder: () => 'روز',
    fieldWeekDayPlaceholder: (params) => (params.contentType === 'letter' ? 'EEEE' : 'EE'),
    fieldHoursPlaceholder: () => 'دقیقه', // Actually it's wrong by lib
    fieldMinutesPlaceholder: () => 'ساعت',
    fieldSecondsPlaceholder: () => 'ثانیه',
    fieldMeridiemPlaceholder: () => 'ق.ظ / ب.ظ',
}

export const FarsiDateTimePicker = (props) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFnsJalali} localeText={persianLocale}>
            <DateTimePicker {...props}/>
        </LocalizationProvider>
    )
}
export const FarsiDatePicker = (props) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFnsJalali} localeText={persianLocale}>
            <DatePicker {...props}/>
        </LocalizationProvider>
    )
}

export default {
    // FarsiDatePicker,
    FarsiDateTimePicker,
};